import React from 'react';
import '../styles/InputStyles.scss';
import PropTypes from 'prop-types';

const CommentInputComponent = ({ value, onChange, required }) => {
  return (
    <div className="comment-input-container">
      <div className='comment-labels'>
        <label className="comment-label" htmlFor="commentInput">
          Оставьте комментарий
        </label>
        {required && (
          <label className="text-asterisk">
            *
          </label>
        )}
      </div>
      <input
        id="commentInput"
        className="comment-input"
        placeholder="Комментарий..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

CommentInputComponent.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CommentInputComponent;
